<div class="sectionContainer paddedContent">
  <h2>Add notes</h2>
</div>
